
/**
 *
 *      Data-driven UI for page layout
 *
 *      @author Irina Patrikeeva <irina.i.patrikeeva@nasa.gov>
 *      Created on 06/02/2017
 *      Modified on 03/11/2019
 */

/**
 * Create Backbone.Marionette views and render them in the layout
 */
function constructView( ) {

    var collection,
        region,
        regions,
        regionsCollection,
        fields,
        data,
        i,
        j,
        urls,
        viewJSON,
        apiJSON,
        urlModel,
        existingModel,
        recordModel;

    if ( GlobalPageState ) {

        recordModel = new BackboneModel( {
            id: GlobalPageState.id,
            pageName: GlobalPageState.currentPage,
            type: GlobalPageState.type,
            page: 1
        });

        viewJSON = getJSONModel( "view", recordModel.get("type"), null );

        // Construct an API for data type
        apiJSON = getJSONModel( "api", recordModel.get("type"), null );

        if ( viewJSON && apiJSON ) {
            collection = getBackboneCollection( viewJSON.properties );
            if (collection) {
                _.each( collection.models, function ( model ) {

                    if ( model.get("page") === recordModel.get("pageName") ) {

                        regions = model.get( "regions" );
                        regionsCollection = new BackboneCollection();

                        for ( i = 0; i < regions.length; ++i ) {
                            region = regions[i];
                            data = [];
                            // Add dependency data name to the data array. It must come before the data name.
                            if ( region.dependsOn ) {
                                for (j = 0; j < region.dependsOn.length; j++ ) {
                                    data.push( region.dependsOn[j] );
                                }
                            }
                            // Add data names needed by this region
                            fields = region.fields; // array of objects
                            if ( fields ) {
                                for (j = 0; j < fields.length; j++) {
                                    data.push( fields[j].data );
                                }
                            }

                            // Construct URLs to get the data
                            urls = constructAPIs( apiJSON, recordModel.get("pageName"), data, recordModel );
                            if ( urls ) {
                                urlModel = new BackboneModel();
                                urlModel.set("urls", urls);
                                urlModel.set("data", data);

                                // If data array is identical, do not create another model for it
                                // Call URL only once for all regions that display the data
                                existingModel = doesModelExist( regionsCollection, data );

                                if (!existingModel) {
                                    regionsCollection.add( urlModel );
                                }
                            }
                        }

                        if ( regionsCollection.models && regionsCollection.models.length > 0 ) {
                            // Get the data and display it in the region
                            getSingleRecordData( regionsCollection, model, recordModel );
                        }
                    }
                });
            }
        }
    }
}

/**
 * Check if a model exists in a collection
 * @param collection {object} - Backbone collection
 * @param data {[string]} - array of data names
 * @returns {boolean}
 */
function doesModelExist(collection, data) {
    var doesExist = false,
        modelData;
    if (collection) {
        _.find(collection.models, function(urlModel) {
            if (urlModel && data) {
                modelData = urlModel.get("data");
                if (modelData.length !== data.length) {
                    return doesExist;
                }
                for (var i = 0; i < data.length; ++i) {
                    if (modelData[i] !== data[i]) {
                        return doesExist;
                    }
                }
                doesExist = true;
            }

        });
    }
    return doesExist;
}

/**
 * Construct layout view on the page
 * @param pageName {string} - name of the page
 * @param type {string} - record data type
 * @param section {string} - name of the page section
 * @returns {Backbone.Marionette.LayoutView} - layout view object
 */
function getLayoutView( pageName, type, section ) {
    var result = null,
        collection,
        layoutPageName,
        recordModel,
        pageId,
        json;

    if ( type ) {
        json = getJSONModel( "layout", type, section );
        if ( json ) {
            collection = getBackboneCollection( json.properties );
            if (collection) {
                _.each(collection.models, function (model) {
                    layoutPageName = model.get("page");
                    if (layoutPageName === pageName) {
                        recordModel = new BackboneModel({ pageName: pageName, pageId: "page-layout", page: 1 });
                        pageId = recordModel.get("pageId");
                        if ( model && pageId ) {
                            result = displayPageLayout( model, pageId );

                            // Display loading icon
                            // Currently the loading text is displayed before anything else is rendered
                            showLoadingIcon( 'page-layout', 'search-loading-icon', 'Loading record' );
                        }
                    }
                });
            }
        }
    }
    return result;
}

/**
 * Add regions to the layout view and display layout view on the page
 * @param model {object} - page JSON model
 * @param pageId {string} - DOM element id of the page
 * @returns {Backbone.Marionette.LayoutView} - layout view object
 */
function displayPageLayout(model, pageId) {
    var template,
        regions,
        i,
        regionId,
        el,
        LayoutView,
        layoutView = null;
    if (model && pageId) {
        template = model.get("template");
        regions = model.get("regions");
        if (template && regions) {
            // Create general page layout view object
            LayoutView = Backbone.Marionette.LayoutView.extend({
                template: template
            });

            // Dynamically add regions to the layout view
            layoutView = new LayoutView({ el: pageId });
            for (i = 0; i < regions.length; ++i) {
                el = regions[i].el;
                layoutView.addRegion(regions[i].name, el);
                if (el && el.length > 0) {
                    regionId = el.substr(1);
                    addRegionElement( regionId, pageId )
                }
            }
        }
    }
    return layoutView;
}

/**
 * Compare data object keys with region field data names
 * @param data {object} - data object
 * @param region {object} - one of the regions from LayoutView model
 * @returns {boolean} - returns true if the keys in the data object match the names of the region field data
 */
function doLayoutFieldsMatch( data, region ) {
    var fields = region.fields,
        dependsOn = region.dependsOn,
        key,
        dataName,
        i,
        k,
        isFound = [],
        dependencyFound = false,
        result = false,
        nFieldSources,
        nDataSources;

    if ( !(hasKeys(fields) && hasKeys(data)) ) {
        return result;
    }

    for (k = 0; k < fields.length; k++) {
        dataName = fields[k].data;
        for (key in data) {
            if (data.hasOwnProperty(key)) {
                if (key === dataName) {
                    isFound.push(true);
                }

                // Data with dependency on other data is passed together in data object. Add it to isFound array.
                if (dependsOn) {
                    for (i = 0; i < dependsOn.length; i++) {
                        if (dependsOn[i] === key) {
                            isFound.push(true);
                            dependencyFound = true;
                        }
                    }
                }
            }
        }
    }

    // Compare field data names in the layout view to data object
    nFieldSources = Object.keys(fields).length;
    nDataSources = Object.keys(data).length;

    // Data with dependency on other data is passed together in data object. Add it to the count of field sources.
    if ( dependsOn && dependencyFound ) {
        nFieldSources++;
    }

    // Return true if number of fields in the layout matches number of fields in the data object
    if ( nDataSources === nFieldSources && nDataSources === isFound.length ) {
        result = true;
    }
    return result;
}


/**
 * Create a child view dynamically
 * @param childObject {object} - JavaScript object of the child view
 * @returns {*} child view or undefined
 */
function createBackboneChildView( childObject ) {
    var childView;
    if ( childObject ) {
        // This works:
        if ( childObject.viewType === "ItemView" ) {
            childView = Backbone.Marionette[ childObject.viewType ].extend({
                template: childObject.template,
                tagName: childObject.tagName,
                className: childObject.className
            });
        }

        // There are no child templates that use CollectionView yet
        if ( childObject.viewType === "CollectionView" && childObject.childView ) {
            childView = Backbone.Marionette[ childObject.viewType ].extend({
                template: childObject.template,
                childView: createBackboneChildView( childObject.childView),
                model: BackboneModel,
                childViewContainer: childObject.childViewContainer
            });
        }
    }
    return childView;
}

/**
 * Show Marionette ItemView in a Marionette LayoutView
 * @param id {string} - unique id of the message element
 * @param view {object} - Backbone region view to show
 * @param layout {object} - Backbone layout view
 */
function showLayoutView( id, view, layout ) {

    var region;
    if ( id && view && layout ) {
        region = layout.getRegion( id );
        if ( region && layout.el ) {
            region.show( view );
        }
    }
}

/**
 * Check if region exists in the DOM and Backbone layout. If not, add it.
 * @param id {string} - unique id of the message element and Backbone region
 * @param regionEl {object} - region outer DOM element
 * @param layoutView {object} - Backbone layout view
 */
function checkLayoutView(id, regionEl, layoutView ) {

    var el,
        regionName;


    if ( id && regionEl && layoutView ) {
        layoutView.render();
        // check if region already exists in the DOM
        if ( $('#' + id ).length === 0 ) {
            el = '<div id="' + id + '"></div>';
            regionEl.append( el );
        }
        // check if region already exists in the layout
        if ( layoutView && layoutView.getRegion( id ) === undefined ) {
            regionName = "#" + id;
            layoutView.addRegion( id, regionName );
        }
    }
}

/**
 * Return a potion of the layout that contains the section
 * @param layout {object} - JSON layout model
 * @param section {string} - section name
 * @returns {object}
 */
function getSectionLayout( layout, section ) {

    var copy,
        regionsToKeep,
        properties,
        regions,
        region,
        regionName,
        regionEl,
        i;

    // make a deep copy of the layout
    copy = jQuery.extend( true, {}, layout );

    // store regions to be kept into an array
    regionsToKeep = [];

    // keep all regions that contain section name
    if ( copy && copy.properties && copy.properties.length === 1 ) {
        properties = copy.properties[0];
        if ( properties ) {
            regions = properties.regions;
            if ( regions && section ) {
                for ( i = 0; i < regions.length; i++ ) {
                    region = regions[ i ];
                    regionName = region.name;
                    regionEl = region.el;

                    // Look for section name in the name of the region or its DOM element

                    if ( regionName && regionEl && ( regionName.toLowerCase().indexOf( section.toLowerCase() ) > -1 || regionEl.toLowerCase().indexOf( section.toLowerCase() ) > -1 ) ) {
                      regionsToKeep.push( region );
                    }
                }
                copy.properties[ 0 ].regions = regionsToKeep;
            }
        }
    }


    return copy;
}